import { useQuery } from '@tanstack/react-query';
import queryTestStandProcessData from 'features/testStand/api/queryTestStandProcessData';
import exportCsv from 'features/testStand/utils/exportCsv';
import { useCallback } from 'react';

export default function useTestStandProcessData({ startTime, endTime }) {
  const query = useQuery({
    queryKey: ['testStandProcessData', startTime, endTime],
    queryFn: () => queryTestStandProcessData({ startTime, endTime }),
    enabled: Boolean(startTime && endTime),
    staleTime: 0,
  });

  const handleExport = useCallback(() => {
    const rows = query.data ?? [];
    const start = new Date(startTime).toISOString().slice(0, 13).replace(/[^0-9T]/g, '');
    const end = new Date(endTime).toISOString().slice(0, 13).replace(/[^0-9T]/g, '');
    exportCsv(rows, `teststand_${start}_${end}.csv`);
  }, [query.data, startTime, endTime]);

  return { ...query, handleExport };
}
